import { render } from "./TheRequisites.vue?vue&type=template&id=5d00a3d1&lang=pug"
import script from "./TheRequisites.vue?vue&type=script&lang=js"
export * from "./TheRequisites.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__